import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { changeSelectedStoryIndex } from 'store';
import { setIsStoryLeftOrRightKeyClicked } from 'store/story/storySlice';

const useArrows = ({ stories }) => {
  const dispatch = useDispatch();

  const open = useSelector((state) => state.storyReducer.storyDetailModal);
  const selectedStoryIndex = useSelector(
    (state) => state.storyReducer.selectedStoryIndex
  );
  const isLeftOrRightKeyClicked = useSelector(
    (state) => state.storyReducer.isLeftOrRightKeyClicked
  );
  const storiesLength = stories?.length - 1 || 0;

  const handleNext = () => {
    if (selectedStoryIndex < storiesLength)
      dispatch(changeSelectedStoryIndex(selectedStoryIndex + 1));
  };

  const handlePrev = () => {
    if (selectedStoryIndex > 0)
      dispatch(changeSelectedStoryIndex(selectedStoryIndex - 1));
  };

  const handleFixedHelpingArrows = () => {
    if (!isLeftOrRightKeyClicked)
      dispatch(setIsStoryLeftOrRightKeyClicked(true));
  };

  useEffect(() => {
    if (open) {
      const handleKeyUp = (event) => {
        if (event.key === 'ArrowRight') {
          handlePrev();
          handleFixedHelpingArrows();
        } else if (open && event.key === 'ArrowLeft') {
          handleNext();
          handleFixedHelpingArrows();
        }
      };

      window.addEventListener('keyup', handleKeyUp);

      return () => {
        window.removeEventListener('keyup', handleKeyUp);
      };
    }
  }, [open, selectedStoryIndex]);

  return { handleNext, handlePrev };
};

export default useArrows;
